export class CustomerTyre {
  _id: String;
  type: String;
  threadDimension1: Number;
  threadDimension2: Number;
  threadDimension3: Number;
  threadDimension4: Number;
  width: string;
  profile: string;
  diameter: string;
  manufacturer: string;
  submissionDate: Date;
  test: string;

}



// WEBPACK FOOTER //
// ./src/app/_models/customerTyre.ts